var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalander(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.42308 16.9167C2.00211 16.9167 1.64579 16.7708 1.35413 16.4792C1.06246 16.1875 0.916626 15.8312 0.916626 15.4102V4.25647C0.916626 3.8355 1.06246 3.47918 1.35413 3.18751C1.64579 2.89585 2.00211 2.75001 2.42308 2.75001H3.57683V0.987305H4.85892V2.75001H11.1731V0.987305H12.4231V2.75001H13.5768C13.9978 2.75001 14.3541 2.89585 14.6458 3.18751C14.9375 3.47918 15.0833 3.8355 15.0833 4.25647V15.4102C15.0833 15.8312 14.9375 16.1875 14.6458 16.4792C14.3541 16.7708 13.9978 16.9167 13.5768 16.9167H2.42308ZM2.42308 15.6667H13.5768C13.641 15.6667 13.6998 15.6399 13.7531 15.5865C13.8066 15.5331 13.8333 15.4744 13.8333 15.4102V7.5898H2.16663V15.4102C2.16663 15.4744 2.19336 15.5331 2.24683 15.5865C2.30017 15.6399 2.35892 15.6667 2.42308 15.6667Z",
    fill: "#3B84E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalander);
export default __webpack_public_path__ + "static/media/Calander.7a9eaf0defb91a48a7f3569d31d18183.svg";
export { ForwardRef as ReactComponent };